<template>
  <div class="receive-message">
    <w-loading v-if="loadingShow" :showText="true" />
  </div>
</template>

<script>
  let moment = require('moment')
  import { updateJWT } from '@/assets/js/utils'

  import WLoading from "@/components/global/w-loading";

  export default {
    data(){
      return {
        loadingShow: true,
        jumpIng: false,
      }
    },
    mounted() {
      // 初始化监听消息
      this.initOnMessages();
    },
    components: {
      WLoading
    },
    methods: {
      // 初始化监听消息
      initOnMessages(){
        let _this = this;
        // 通知父级加载完成
        window.parent.postMessage({
          type: 'loaded'
        },'*');
        // 接受父级发送的跳转信息及用户信息
        window.addEventListener('message', async function(event){
          let data = event.data || {};
          console.log('子页面messages.data', data,)
          if(data.jwt && data.jwt_timestamp){
            let { jwt, jwt_timestamp, jumpUrl, hostname} = data;

            await updateJWT({
              jwt,
              jwt_timestamp: jwt_timestamp,
              cookieEndTime: (jwt_timestamp - Math.floor(new Date().getTime()/1000)) / 24 / 60 / 60
            }, false, hostname)
            if(_this.jumpIng){
              return
            }
            setTimeout(() => {
              console.log(jumpUrl)
              window.location.href = jumpUrl
              // _this.$router.push(jumpUrl)
              _this.jumpIng = true;
            }, 500);
          }
        }, false);
      },
    },
    
  }
</script>
<style scoped lang="scss">
  .receive-message{
    width: 100vw;
    height: 100vh;
  }
</style>